'use client';

import { useRouter } from 'next/navigation';
import React, { FC, useState } from 'react';

import type { NewsType } from '@/api/config/types';
import type { ListResponse } from '@/api/types';
import Image from '@/components/core/Image';
import Share from '@/components/popups/Share';

import News from '../components/News';

type Props = {
  news: NewsType;
  isBlogPage?: boolean;
  recommended: ListResponse<NewsType>;
  params: { lang: string; slug: string };
};

const NewsPageClient: FC<Props> = ({ news, recommended, params, isBlogPage }) => {
  const [isSharePopupOpen, setIsSharePopupOpen] = useState(false);
  const router = useRouter();

  const onGoBack = () => {
    router.back();
  };

  return (
    <div className="newsPageWrapper">
      <div className="bigContent">
        <div className="upcomingEventsWrapper">
          <div className="upcomingEventsTitleRow">
            <button onClick={onGoBack} className="upcomingGoLink">
              <i className="bc-i-arrow-left upcomingGoBackIcon" />
              <span className="upcomingGoBackText">Back</span>
            </button>
          </div>
          <div className="upcomingContentWrp">
            <div className="upcomingContentTopRow">
              <p className="contentTopDateText">
                <span>{news.date}</span>
              </p>
              <h1 className="upcomingContentHeadingText">{news.title}</h1>
              <div className="upcomingHeadRow">
                <div className="upcomingButtonsRow">
                  {(news.tags || '')
                    .split(',')
                    .filter(Boolean)
                    .map((item, index) => {
                      const isOdd = index % 2 !== 0;
                      return (
                        <div className={`upcomingButtonCont ${isOdd ? 'red' : 'green'}`} key={item}>
                          <span className="upcomingButtonContText">{item}</span>
                        </div>
                      );
                    })}
                  <div className="upcomingDownloadBtnWrp">
                    <button
                      className="upcomingDownloadBtn"
                      onClick={() => setIsSharePopupOpen(true)}
                    >
                      <i className="bc-i-download upcomingDownloadBtnIcon" />
                    </button>
                  </div>
                  {isSharePopupOpen && <Share close={setIsSharePopupOpen} />}
                </div>
              </div>
            </div>
            <div className="upcomingImgCont">
              {news.logo && (
                <div className="upcomingImgContInner">
                  <Image
                    alt="#"
                    width={1600}
                    height={800}
                    src={news.logo}
                    className="upcomingImg"
                  />
                </div>
              )}
            </div>
            <div className="upcomingMainContent">
              <div
                className="upcomingMainDesc"
                dangerouslySetInnerHTML={{ __html: news.description }}
              />
            </div>
          </div>
        </div>
      </div>
      {recommended.query.length > 0 && !isBlogPage && (
        <News
          limit={3}
          title="Recommended"
          newsList={recommended}
          innerClassName="newsBigContWrp"
        />
      )}
    </div>
  );
};

export default NewsPageClient;
